import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpContext, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {IHttpRequest} from '../models/http-request.interface';
import {checkContextAndCreate} from '../utils/methods/createContext';

@Injectable({
  providedIn: 'root'
})
export class ApiService implements IHttpRequest {
  private http = inject(HttpClient);

  get<T>(url: string, params?: any, context?: any): Observable<T> {
    let httpContext: HttpContext;
    if (context) {
      httpContext = checkContextAndCreate(context);
    }
    return this.http.get<T>(url, {params, context: httpContext});
  }

  getById<T>(url: string, id: string | number, context?: any): Observable<T> {
    return this.http.get<T>(`${url}/${id}`, {context});
  }

  post<T>(url: string, data: any, context?: HttpContext): Observable<T> {
    return this.http.post<T>(url, data, {context});
  }

  put<T>(url: string, data?: any, context?: any): Observable<T> {
    return this.http.put<T>(url, data, {context});
  }

  delete<T>(url: string, id: string | number, context?: any): Observable<T> {
    return this.http.delete<T>(`${url}/${id}`, {context});
  }
}
